import { Grid } from "@mui/system";
import { Typography } from "@mui/material";

import AnomaliesMissingDataTable, {
  MISSING_DATA_EXPORT_COLUMNS,
} from "./AnomaliesMissingDataTable";
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import AnomaliesSkeleton from "../../AnomaliesSkeleton";
import BrandSearchBar from "../Utils/BrandSearchBar";
import { exportRowsToCsv } from "../Utils/anomaliesColumns";

const AnomaliesMissingData = () => {
  const [choosenBrand, setChosenBrand] = useState<string | null>(null);

  const missingData = useSelector(
    (state: any) => state.bizDevelopmentAnomalies.missingData,
  );

  //Meta data for dynamic table headings
  const missingMetadata = useSelector(
    (state: any) => state.bizDevelopmentAnomalies.missingMetadata,
  );
  //is Fetched data for Missing Data
  const isFetchedForMissingData = useSelector(
    (state: any) => state.bizDevelopmentAnomalies.isFetchedForMissingData,
  );

  //-- Extract unique brand names for Autocomplete filter
  const brandNames = useMemo(() => {
    const set = new Set<string>();
    (missingData || []).forEach((r: any) => {
      if (typeof r?.brand_display_name === "string")
        set.add(r.brand_display_name.trim());
    });
    return Array.from(set);
  }, [missingData]);

  // filter rows by the chosen brand
  const filteredData = useMemo(() => {
    const search = (choosenBrand ?? "").trim().toLowerCase();
    if (!search) return missingData;
    return missingData.filter((row: any) =>
      String(row.brand_display_name ?? "")
        .toLowerCase()
        .includes(search),
    );
  }, [missingData, choosenBrand]);

  return (
    <>
      {isFetchedForMissingData ? (
        <>
          <Grid container spacing={2} alignItems="center" px={2} py={1.5}>
            <Grid size={8}>
              <Typography variant="body1" fontSize={18}>
                Missing Data in the Last 2 Days
              </Typography>
            </Grid>
            <Grid size={4}>
              <BrandSearchBar
                dataTrackerForSearch="872"
                brandNames={brandNames}
                chosenBrand={choosenBrand}
                onBrandChange={setChosenBrand}
                dataTrackerForDownload="870"
                onDownload={() =>
                  exportRowsToCsv(
                    filteredData,
                    MISSING_DATA_EXPORT_COLUMNS,
                    "missing-data.csv",
                  )
                }
                disabled={missingData.length === 0 || !isFetchedForMissingData}
              />
            </Grid>
          </Grid>
          <AnomaliesMissingDataTable
            metadata={missingMetadata}
            rows={filteredData}
          />
        </>
      ) : (
        <AnomaliesSkeleton />
      )}
    </>
  );
};

export default AnomaliesMissingData;
